import PropertiesList from "../components/PropertiesList.tsx";
import type { User } from "firebase/auth";

interface PropertiesProps {
    user: User | null;
}

const Properties: React.FC<PropertiesProps> = ({ user }) => {
    if (!user) {
        return <div>Please Login</div>;
    }

    return (
        <div className="w-full max-w-[1440px] py-4 mx-auto px-[5%]">
            <div className="mb-8">
                <div className="flex justify-between items-center mb-4 min-w-min">
                    <h2 className="text-2xl font-semibold">Properties</h2>
                </div>

                <PropertiesList />
            </div>
        </div>
    );
};

export default Properties; 